<template>
	<div>
		<v-dialog
				class="factoringModal"
				v-model="dialog"
				fullscreen
				hide-overlay
				transition="dialog-bottom-transition"
				scrollable
		>
			<v-card tile class="main">
				<v-card-title
						flat
						fixed app
						color="primary"
						class="card-header"
				>
					<v-btn
							icon
							@click="closeCreate"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
					<div class="ml-3">
						<h5>Add factoring company</h5>
						<h5 class="subheadId">Factoring company controls: ID {{ companyData.id }} </h5>
					</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-list-item class="d-flex mt-4">
						<div class="payment-wrapper d-flex">
							<!-- Name inp-->
							<div class="field-wrapper mr-5 ml-5 mt-2">
								<v-text-field
										class="width-200 required field"
										label="Factoring company name"
										v-model="companyData.name"
										dense
										required
								></v-text-field>
							</div>
							<div class="field-wrapper__with-icon mt-2 mr-5">
								<v-text-field
										class="width-200 required field"
										label="Percent"
										type="number"
										v-model="companyData.percent"
										dense
										required
								></v-text-field>
								<v-icon
										class="mt-8 ml-5"
										small

								>
									mdi-percent-outline
								</v-icon>
							</div>
						</div>
					</v-list-item>
					<v-list-item class="d-flex flex-column mt-5">
						<v-tabs
								v-model="tab"
						>
							<v-tab
									v-for="item in items"
									:key="item.tab"
							>
								{{ item.tab }}
							</v-tab>
						</v-tabs>

						<v-tabs-items v-model="tab" style="width:100%;" class="mt-5">
							<v-tab-item>
								<v-card flat>
									<div class="d-flex ">
										<v-list
												for-line
												subheader
												class="info-data"
										>
											<div class="payment-wrapper mr-5">
												<v-subheader>Factoring company info</v-subheader>
												<v-list-item>
													<div class="field-wrapper">
														<v-text-field
																placeholder="777-77-77"
																class="width-200 required field"
																label="Phone"
																v-model="companyData.phone"
																:rules="[v => !!v || 'You must agree to continue!']"
																dense
																required
														>
														</v-text-field>
													</div>
												</v-list-item>
												<v-list-item>
													<div class="field-wrapper d-flex flex-row align-center">
														<autocomplete-loads
																v-on:back-data="getLoctionBack"
																:data-location="modelLoaction"
																:permissions="permissions"
																:security="'required'"
																:readonly-flag="false"
														></autocomplete-loads>
														<v-tooltip color="orange" right>
															<template v-slot:activator="{ on, attrs }">
																<v-btn
																		v-bind="attrs"
																		v-on="on"
																		@click="createAddress"
																		class="ml-auto"
																		color="green "
																		fab
																		icon
																		small
																>
																	<v-icon>mdi-plus</v-icon>
																</v-btn>
															</template>
															<span>Create Address</span>
														</v-tooltip>
													</div>
												</v-list-item>
												<v-list-item>
													<!-- Adress inp -->
													<div class="field-wrapper text factoring_address">
														<v-textarea
																class="width-200 field textarea"
																label="Adress"
																v-model="companyData.address"
																placeholder="Enter address (street, building, office, etc.)"
																dense
																required
														>
														</v-textarea>
													</div>
												</v-list-item>
												<v-list-item>
													<!-- Fax inp -->
													<div class="field-wrapper">
														<v-text-field
																class="field"
																label="Fax"
																v-model="companyData.fax"
																placeholder="Fax"
																dense
														>
														</v-text-field>
													</div>
												</v-list-item>
											</div>
										</v-list>
										<v-list
												for-line
												subheader
										>
											<div class="payment-wrapper">
												<div class="d-flex">
													<v-subheader>Payment type</v-subheader>

													<v-tooltip top>
														<template v-slot:activator="{ on, attrs }">
															<v-icon
																	color="primary"
																	v-bind="attrs"
																	v-on="on"
															>
																mdi-information-outline
															</v-icon>
														</template>
														<span>Fixed payment for 1 form</span>
													</v-tooltip>
													<v-btn fab icon small class="ml-auto mr-5 mt-2" @click="addPayment">
														<v-icon color="green">mdi-plus</v-icon>
													</v-btn>
												</div>
												<!-- Payment -->
												<div class="d-flex align-start" v-for="(payment, index) in companyData.payment_type"
												     :key="index">
													<v-list-item>
														<div class="field-wrapper ">
															<v-text-field
																	placeholder="Payment type"
																	v-model="payment.name"
																	class="width-200 required field"
																	label="Enter payment type name"
																	dense
																	required
															>
															</v-text-field>
														</div>
													</v-list-item>
													<v-list-item>
														<div class="field-wrapper__with-icon ml-1">
															<v-text-field
																	v-model="payment.amount"
																	class="width-200 required field"
																	label="Amount"
																	type="number"
																	dense
																	required
															></v-text-field>
														</div>
													</v-list-item>
													<v-list-item>
														<v-btn fab icon small class="mt-7" @click="deletePayment(payment)">
															<v-icon>mdi-delete-outline</v-icon>
														</v-btn>
													</v-list-item>
												</div>
											</div>
										</v-list>
									</div>
								</v-card>
							</v-tab-item>
							<!-- Notes -->
							<v-tab-item>
								<div>
									<div class="payment-wrapper d-flex flex-column">
										<div class="d-flex ">
											<v-subheader>Notes</v-subheader>
											<div class="ml-auto mr-2">
												<v-btn fab icon small @click="addNewNote">
													<v-icon color="green">mdi-plus</v-icon>
												</v-btn>
												<span>Add note</span>
											</div>
										</div>
										<div>
											<TableModule
													:header-table="header"
													:data-table="getNotesData"
													:permissions="permissions"
													:delete-item="true"
													v-on:delete-action="deleteItem"
													:sort-desc-default="false"
													v-on:edit-item="editItem"
													ref="table"
											/>
										</div>
									</div>
								</div>
							</v-tab-item>
						</v-tabs-items>
						<transition name="slide-fade">
							<FormNotes v-if="toCreate" :close-form="closeFrom" :getNote="editableItem">
								<template slot="form" slot-scope="{ on, getNote }">
									<CreateFactoring @on="on" :getNote="getNote" :editableNote="editableNote" :permissions="permissions"/>
								</template>
								<template slot="actions" slot-scope="{ note }">
									<div class="actions mt-auto pr-4 width-max d-flex justify-center">
										<v-btn
												class="mr-2 actions-btn width-200 btn-wr"
												@click="closeFrom"
												color="rgba(143, 144, 166, 0.2)"
										>cancel
										</v-btn
										>
										<v-btn
												class="btn-success ml-2 actions-btn width-200 btn-wr"
												@click="saveNotes(note)"
										>save
										</v-btn
										>
										<div @click="closeFrom" class="back-drop"></div>
									</div>
								</template>
							</FormNotes>
						</transition>
					</v-list-item>
					<v-overlay :opacity="0.5" :value="overlay">
						<v-card color="grey darken-4">
							<v-container class="d-flex justify-end">
								<v-btn color="green darken-4 ml-auto" @click="saveAddress">Save</v-btn>
								<v-btn color="red darken-2 ml-4" @click="close">Close</v-btn>
							</v-container>
							<City v-if="overlay" :data-items="editedItem"/>
						</v-card>
					</v-overlay>
					<v-divider></v-divider>
				</v-card-text>
				<div style="flex: 1 1 auto;"></div>
				<div class="d-flex flex-row justify-end mr-16">
					<v-btn @click="closeCreate" class="mr-2 actions-btn  btn-wr">
						Cancel
					</v-btn>
					<v-btn :disabled="!permissions['9']" @click="saveForm" class="btn-success ml-2 actions-btn btn-wr">
						Save
					</v-btn>
				</div>
			</v-card>

		</v-dialog>
	</div>
</template>
<script>
import Vuex from "vuex";
import AutocompleteLoads from "@/shared/autocomplet/autocomplete.loads.vue";
import TableModule from "@/shared/table/table.module";
import FormNotes from "./FromNotes/FormNotes.vue";
import CreateFactoring from './FactoringCreate.vue';
import FactoringModule from "@/store/modules/safety/factoring.module";
import City from '@/components/Settings/cities/city/city.component';

const store = new Vuex.Store();
store.registerModule('FactoringModule', FactoringModule);

const modelPayment = { name: '', amount: 0 };
export default {
	components: {
		AutocompleteLoads,
		TableModule,
		FormNotes,
		CreateFactoring,
		City
	},
	props: {
		permissions: {
			type: Object
		},
		dialog: {
			type: Boolean
		},
		companyData: {
			type: Object,
			default: () => ({
				name: '',
				phonname: '',
				phone: '',
				city: '',
				city_id: '',
				address: '',
				fax: '',
				id: null,
				state: '',
				zip_code: '',
				state_id: '',
				percent: null,
				notes_rows: [],
				payment_type: []
			})
		}
	},
	data: () => ({
		editableNote: false,
		overlay: false,
		newAddress: false,
		editedItem: null,
		cityAdd: false,
		deltedPayment: null,
		deleted: [],
		indexEdit: null,
		userData: {},
		toCreate: false,
		countIdPayment: 0,
		tab: null,
		editableItem: {},
		noteModel: {
			create_at: new Date().toISOString().substr(0, 10),
			created_by: "",
			notes: "",
			status: null,
			id: null
		},
		items: [
			{ tab: 'General info', content: 'Tab 1 Content' },
			{ tab: 'Notes', content: 'Tab 2 Content' },
		],
		model: {
			loction: {
				city: '',
				city_id: '',
				state: '',
				state_id: '',
				zip_code: '',
			}
		},
		phoneRules: [
			(v) =>
				/^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/g.test(v) ||
					"Phone must be valid",
		],
		header: [
			{
				text: "Create date",
				value: "create_at",
				func: false,
				sortable: false,
				checkbox: false,
			},
			{
				text: "Created by",
				value: "created_by",
				func: false,
				sortable: false,
				checkbox: false,
			},
			{
				text: "Note",
				value: "notes",
				func: false,
				sortable: false,
				checkbox: false,
			},
			{
				text: "",
				value: "",
				func: false,
				sortable: false,
				del: true
			},
		]
	}),
	async mounted() {
		this.$store.dispatch("actionPreloader", true);
		this.$store.dispatch("getDataUser").then((resp) => {
			if (resp.user) {
				Object.assign(this.userData, resp.user);
				this.$store.dispatch("actionPreloader", false);
			}
		});
	},
	computed: {
		getNotesData() {
			return this.companyData.notes_rows;
		},
		modelLoaction() {
			return {
				loction: {
					city: this.companyData.city,
					city_id: this.companyData.city_id,
					state: this.companyData.state,
					state_id: this.companyData.state_id,
					zip_code: this.companyData.zip_code,
				}
			};
		}
	},
	methods: {
		createAddress() {
			this.newAddress = true;
			this.editedItem = {
				city: {
					city: null,
					city_id: null,
					state: null,
					state_id: null,
					zip: [],
				},
			};
			this.showEditCity();
		},
		showEditCity() {
			this.overlay = true;
		},
		async saveAddress() {
			this.setAddress();
		},

		async setAddress() {
			this.$store.dispatch("actionPreloader", true);
			this.$store.dispatch("setAddress", this.editedItem.city).then((resp) => {
				if (resp.status !== 200 && !resp.data.city_id) {
					this.$store.dispatch("setAlert", {
						type: "error",
						message: "Saving error",
					});
				}
				this.$store.dispatch("actionPreloader", false);
				this.close();
			});
		},
		close() {
			this.overlay = false;
			this.editedItem = null;
			this.newAddress = false;
		},
		// addCity(){
		//     this.cityAdd = true;
		//     this.$refs.cityForm.open()
		// },
		editItem(value, index) {
			this.indexEdit = index;
			Object.assign(this.editableItem, value);
			this.getNotesData[index].created_by === this.userData.name ? this.toCreate = true : this.toCreate = false;
		},
		saveNotes(value) {
			if (this.indexEdit !== null) {
				this.getNotesData.splice(this.indexEdit, 1, value);
			} else {
				this.getNotesData.unshift({
					...value,
					created_by: this.userData.name,
					create_at: new Date().toISOString().substr(0, 10),
				});
			}
			this.closeFrom();
		},
		closeFrom() {
			this.toCreate = false;
			this.indexEdit = null;
			this.editableItem = { notes: '', created_by: '', create_at: '' };
		},
		addNewNote() {
			this.toCreate = true;
		},
		deleteItem(item) {
			if (this.userData.name != item.created_by) return;
			item.status = '0';
			const delIndex = this.getNotesData.findIndex((note) => {
				if (note.status == "0") {
					this.deleted.push(note);
				}
				return note.status == "0";
			});
			this.getNotesData.splice(delIndex, 1);

		},
		getLoctionBack(location) {
			this.model.loction = location;
		},
		addPayment() {
			this.countIdPayment += 1;
			this.companyData.payment_type.unshift(Object.assign({}, modelPayment));
		},
		deletePayment(value) {
			value.status = '0';
			const index = this.companyData.payment_type.findIndex(payment => {
				if ((payment.payment_type === value.payment_type && payment.payment_amount === value.payment_amount)) {
					this.deletedPayment = payment;
				}
				return (payment.payment_type === value.payment_type && payment.payment_amount === value.payment_amount);
			});
			this.companyData.payment_type.splice(index, 1);
		},
		saveForm() {
			this.deleted.length && this.getNotesData.push(...this.deleted);
			let payment_type = [ ...this.companyData.payment_type, this.deletedPayment ];
			if (!this.deletedPayment) payment_type = [ ...this.companyData.payment_type ];
			const compData = {
				...this.companyData,
				notes_rows: [ ...this.getNotesData ],
				payment_type: payment_type
			};
			this.$emit('save-form', compData);
			this.$emit('close-create', false);
		},
		closeCreate() {
			this.$emit('close-create', false);
		}
	},
	watch: {
		'model.loction.city'(valu) {
			this.companyData.city = valu;
		},
		'model.loction.state'(valu) {
			this.companyData.state = valu;
		},
		'model.loction.zip_code'(valu) {
			this.companyData.zip_code = valu;
		},
		'model.loction.city_id'(valu) {
			this.companyData.city_id = valu;
		},
		'model.loction.state_id'(valu) {
			this.companyData.state_id = valu;
		},
	}
};
</script>
<style lang="scss" scoped>
@import "FactoringCreateNew";

</style>
<style lang="scss">
@import "FactoringCreateAllNew";
</style>
